var _path, _path2, _path3, _path4, _path5, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurbside(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43884 9.86367L7.16897 3.77902C7.68384 2.40726 8.99586 1.49899 10.4611 1.5H24.3256C25.791 1.49809 27.1035 2.40668 27.6176 3.77902L30.3509 9.86679",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17383 19.9191V22.5728C2.17383 23.8659 3.22213 24.9142 4.51528 24.9142C5.80843 24.9142 6.85673 23.8659 6.85673 22.5728V20.2313",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1559 12.0365C32.3189 10.5867 30.7715 9.694 29.0974 9.69507H5.6829C3.09661 9.69507 1 11.7917 1 14.378V17.8901C1 19.1833 2.0483 20.2316 3.34145 20.2316H12.7073",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7805 19.001H21.0325C20.449 18.9772 19.938 19.3889 19.8372 19.9641L18.1723 31.5473C18.1549 31.8689 18.2756 32.1827 18.504 32.4097C18.7325 32.6367 19.047 32.7554 19.3685 32.736H34.4445C34.766 32.7555 35.0804 32.6367 35.3088 32.4097C35.5371 32.1826 35.6576 31.8688 35.6399 31.5473L33.9751 19.9641C33.8742 19.3892 33.3637 18.9776 32.7805 19.001Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9611 15.5447C29.679 14.0715 28.3927 13.0047 26.8928 13V13C25.4006 13.0065 24.1202 14.0647 23.8328 15.5289",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 15.5,
    r: 2.5,
    stroke: "black",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurbside);
export default __webpack_public_path__ + "assets/media/curbside.d5af0fa3448e499deae83e16da55f8e1.svg";
export { ForwardRef as ReactComponent };